import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { scrollToTop } from "../libraries/ercLibrary";

export default function useScrollRestorationLand(path) {
  const history = useHistory();
  const height = sessionStorage.getItem(path);

  useEffect(() => {
    history.listen((location, action) => {
      if (action === "POP") {
        const heightRestore = sessionStorage.getItem(path);
        setTimeout(() => {
          scrollToTop(heightRestore);
        }, 1000);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!height) {
      setTimeout(() => {
        return window.scrollTo({
          top: -100,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    }
  }, [height]);
}
